import theme from "@/styles/theme";
import { Container, Grid } from "@mui/material";
import { grey } from "@mui/material/colors";
import { NetworkAboutFeatureCard } from "../network";

export const AboutAdditionalInfos = ({content}) => {
  return (
    <>
      <Container maxWidth="xl">
        <Grid
          container
          justifyContent="center"
          sx={{
            backgroundColor: `${
              content.background_color === "lightgrey"
                ? grey[100]
                : content.background_color === "white"
                ? theme.palette.common.white
                : ""
            } !important`,
            py: 3,
            [theme.breakpoints.up("md")]: {
              py: 6,
            },
          }}
        >
          <Grid item xs={10}>
            <Grid container spacing={3}>
              {content.Additional_Infos_Block.map((block) => {
                return (
                  <Grid key={block.id} item xs={12} md={4}>
                    <NetworkAboutFeatureCard
                      image={block.image}
                      headline={block.title}
                      text={block.text}
                      buttontext={block.button_text}
                      link={block.button_link}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default AboutAdditionalInfos;
